import graphql__fa8c4f8d4a1ac75c2f31 from "./__generated__/ContactsViewContactsQuery.graphql.ts";import * as React from "react";
import {useState, useEffect, useCallback} from "react";
import Panel from "./presentational/Panel";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import Headline from "./presentational/Headline";
import ActionButton from "./presentational/button/ActionButton";
import {faPlusCircle} from "@fortawesome/pro-regular-svg-icons";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import CreateContactDialog from "./dialog/CreateContactDialog";
import ContactList from "./ContactList";
import ContactsQuery from "./__generated__/ContactsViewContactsQuery.graphql";
import ListSearch from "./presentational/ListSearch";
import {useSearchParams} from "react-router-dom";
import {useIntl} from "react-intl";

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type Props = {
    prepared: any
};

type ContactsViewProps = ConnectedProps<typeof connector> & Props;

const ContactsView: React.FC<ContactsViewProps> = (props) => {
    const intl = useIntl();
    const {dispatchShowModal, dispatchHideModal} = props
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
    const [isSearching, setIsSearching] = useState(false);

    const contacts = usePreloadedQuery(
        graphql__fa8c4f8d4a1ac75c2f31,
        props.prepared.contactsQuery,
    );

    // Update URL when search term changes
    const updateURL = useCallback((term: string) => {
        const newParams = new URLSearchParams(searchParams);
        if (term.trim()) {
            newParams.set('search', term);
        } else {
            newParams.delete('search');
        }
        setSearchParams(newParams, { replace: true });
    }, [searchParams, setSearchParams]);

    const searchAPIDebounced = AwesomeDebouncePromise(
        (searchTerm: string) => {
            setSearchTerm(searchTerm);
            updateURL(searchTerm);
        },
        500
    );

    const handleSearchTermChange = (searchTerm: string) => {
        searchAPIDebounced(searchTerm);
    };

    // Initialize search term from URL changes (browser navigation)
    useEffect(() => {
        const urlSearchTerm = searchParams.get('search') || '';
        setSearchTerm(urlSearchTerm);
    }, [searchParams]);

    const showCreateContactDialog = () => {
        dispatchShowModal({
            body: (<CreateContactDialog handleCloseDialog={dispatchHideModal}/>)
        })
    };

    return (
        <div className="lg:mt-6 mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.contacts.headline'})}</Headline>
                        </div>
                        <div className="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                            <ActionButton icon={faPlusCircle} title={intl.formatMessage({id: 'view.contacts.createButton'})} onClick={() => {
                                showCreateContactDialog()
                            }}/>
                        </div>
                    </div>
                    <ListSearch
                        handleSearchTermChange={handleSearchTermChange}
                        placeholder={intl.formatMessage({id: 'view.contacts.searchPlaceholder'})}
                        initialValue={searchTerm}
                        isLoading={isSearching}
                    />
                </div>
                <ContactList
                    queryRef={contacts}
                    searchTerm={searchTerm}
                    onLoadingChange={setIsSearching}
                />
            </Panel>
        </div>
    )
}

export default connector(ContactsView);

function prepare_ContactsView(params, relayEnvironment) {
    return {
        contactsQuery: loadQuery(
            relayEnvironment,
            ContactsQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_ContactsView};
